import { render, staticRenderFns } from "./UnitCourse.vue?vue&type=template&id=3652407c"
import script from "./UnitCourse.vue?vue&type=script&lang=js"
export * from "./UnitCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports